import * as React from 'react';

function SvgHouse(props) {
  return (
    <svg width={30} height={28} fill="none" viewBox="0 0 30 28" {...props}>
      <g clipPath="url(#house_svg__clip0)">
        <path d="M29.4326 13.1948L16.1461 1.46324C15.8321 1.18549 15.4399 1.04688 15.0482 1.04688C14.7254 1.04688 14.3112 1.14405 13.9503 1.46324L0.569052 13.1948C-0.585635 14.2149 0.135823 16.1447 1.66697 16.1447H3.33468L3.33405 24.5582C3.33405 26.417 4.82623 27.9236 6.62051 27.9236H23.2403C25.0814 27.9236 26.5268 26.417 26.5268 24.5582L26.5266 16.1447L28.1464 16.1447C29.0703 16.1447 29.8136 15.3875 29.8136 14.5093C29.9534 13.9835 29.8024 13.5208 29.4326 13.1948ZM20.7138 15.9186C20.7138 16.7268 20.4164 17.5382 19.8248 18.1582L15.5086 22.6588C15.3684 22.8036 15.1799 22.8772 14.9982 22.8772C14.8165 22.8772 14.6281 22.8036 14.4878 22.6588L10.1743 18.1582C9.58155 17.5377 9.28572 16.7268 9.28572 15.9181C9.28572 14.3653 10.4493 12.7809 12.2649 12.7809C13.0951 12.7809 13.9383 13.1259 14.5576 13.7721L14.9534 14.2307L15.3914 13.7688C16.0143 13.1225 16.8565 12.7776 17.6883 12.7776C19.542 12.732 20.7138 14.3095 20.7138 15.9186Z" />
      </g>
      <defs>
        <clipPath id="house_svg__clip0">
          <path d="M0 0H30V28H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default SvgHouse;
